import React, {
  lazy,
  useLayoutEffect,
} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Page404 from "./pages/404";
import ForgotPassword from "./pages/ForgotPassword";
import CreateAccount from "./pages/CreateAccount";

import { jwtDecode } from "jwt-decode";
import { LogIt } from "./pages/Login";
import PublicBookProfile from "./pages/public/PublicBookProfile";
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const Archive = lazy(() => import('./pages/PublicArchive'))

export const AuthContext = React.createContext();

// Utility function to check if the token is expired
const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    return true; // If there's an error decoding the token, consider it expired
  }
};

// Function to remove the token if it is expired
const removeExpiredToken = () => {
  const token = sessionStorage.getItem("token");
  if (token && isTokenExpired(token)) {
    sessionStorage.clear();
    console.log("Token removed due to expiration");
    window.location.href = "/";
  }
};

// Call this function when your application starts or at specific events
function App() {
  useLayoutEffect(() => {
    // Function to periodically check and remove the expired token
    const intervalId = setInterval(() => {
      removeExpiredToken();
    }, 60000); // Check every 60 seconds (60000 milliseconds)
    removeExpiredToken();

    // Cleanup function to remove the event listener
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  var token = sessionStorage.getItem("token");
  var user;

  try {
    user = token && jwtDecode(token);
  } catch (e) {
    sessionStorage.clear();
    window.location.href = "/";
  }

  function refresh() {
    token = sessionStorage.getItem("token");
    if (!token) return;
    try {
      user = token && jwtDecode(sessionStorage.getItem("token"));
      var nivelAcceso = 0;
      switch (user.rol) {
        case "ADMINISTRADOR":
          nivelAcceso = 5; /* PUEDE REPORTAR */
          break;

        case "BIBLIOTECARIO":
          nivelAcceso = 4; /* PUEDE BORRAR */
          break;

        case "GESTOR":
          nivelAcceso = 3; /* PUEDE CREAR */
          break;

        case "PASANTE":
          nivelAcceso = 2; /* PENDENITE DE ASOCIAR */
          break;
        case "DOCENTE":
          nivelAcceso = 1; /* PENDENITE DE ASOCIAR */
          break;
        default:
          break;
      }
      user.nivelAcceso = nivelAcceso;
      const decodedHeader = jwtDecode(sessionStorage.getItem("token"), {
        header: true,
      });
      console.log("decodedHeader", decodedHeader);
    } catch (e) {
      sessionStorage.clear();
      window.location.href = "/";
    }
  }
  refresh();

  // decode header by passing in options (useful for when you need `kid` to verify a JWT):

  return (
    <AuthContext.Provider value={{ token, user, refresh }}>
      <Router>
        <Routes>
          {!token ? (
            <>
              <Route path="*" element={<Login />} />
              <Route path="/tk/:token" element={<LogIt />} />
              <Route path="/biblioteca/:id" element={<PublicBookProfile />} />
              <Route path="/" element={<Archive />} />
              <Route path="create-account" element={<CreateAccount />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
            </>
          ) : (
            <>
              <Route path="/tk/:token" element={<LogIt />} />
              <Route path="/" element={<Layout />}>
                <Route path="*" element={<Page404 />} />
              </Route>
            </>
          )}
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
